import { occBaseSiteUrl, occFetch } from "~/app/api/occ/occFetch";
import { occCartUserPath } from "~/app/api/occ/occUserPath";
import { transform, type QuoteResponseDTO } from "~/features/cart/activeQuote/transformers/quoteViewDataTransformer";
import { resolveActiveCartResourceId } from "~/features/cart/cart/utils/cartResourceIdentity";
import type { TransformedCartData } from "~/features/cart/cart/transformers/CartResponseTransformer";
import type { QuoteCartViewDTO } from "../../cart/dto/QuoteCartViewDTO";

export async function getData(): Promise<TransformedCartData> {
  const activeCartId = await resolveActiveCartResourceId();
  if (!activeCartId) {
    throw new Error("Cannot load quote data without an explicit Active Cart identity");
  }
  const response = await occFetch(
    occBaseSiteUrl(`${occCartUserPath()}/carts/${encodeURIComponent(activeCartId)}/quote-data`),
  );
  const oldDto: QuoteCartViewDTO = await response.json();
  const dto = preprocessData(oldDto);
  return transform(dto);
}

function preprocessData(dto: QuoteCartViewDTO): QuoteResponseDTO {
  return {
    code: dto.code,
    entries: dto.entries,
    dstError: dto.dstError,
    quoteAccount: dto.quoteAccount,
  };
}
